import { cn } from '@/lib/utils';

export interface PageTab { id: string; label: string }

export interface PageTabsProps {
  tabs: PageTab[];
  active: string;
  onSelect: (id: string) => void;
  label?: string;
  className?: string;
}

/** Use to switch between URL-driven views of one page; rendered as navigation (not an ARIA tablist). */
export function PageTabs({ tabs, active, onSelect, label = 'Sections', className }: PageTabsProps) {
  return (
    <nav aria-label={label} className={cn('flex flex-wrap gap-x-6 border-b', className)}>
      {tabs.map((t) => (
        <button
          key={t.id}
          type="button"
          aria-current={active === t.id ? 'page' : undefined}
          onClick={() => onSelect(t.id)}
          className={cn(
            '-mb-px rounded-sm border-b-2 pb-2.5 text-sm font-medium transition-colors outline-none focus-visible:ring-2 focus-visible:ring-ring',
            active === t.id ? 'border-primary text-foreground' : 'border-transparent text-muted-foreground hover:text-foreground',
          )}
        >
          {t.label}
        </button>
      ))}
    </nav>
  );
}
